import PropTypes from 'prop-types';

export const blogCardSliderPropTypes = {
  /**
   * List of blog card data to display in the slider.
   * Each object in the list should represent a blog with a title, content, image URL, and alternate text for the image.
   *
   * @type {Array<{title: string, content: string, image: string, imageAlt: string}>}
   */
  blogCardList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      imageAlt: PropTypes.string.isRequired,
      buttonLabel: PropTypes.string,
      cardTitle: PropTypes.string,
    }),
  ).isRequired,
  /**
   * Duration of the slide transition in seconds.
   * Default value is 0.75 seconds.
   *
   * @type {number}
   */
  slideSpeed: PropTypes.number,
  /**
   * Duration of the shake animation in seconds.
   * Default value is 0.3 seconds.
   *
   * @type {number}
   */
  shakeDuration: PropTypes.number,
  /**
   * Elevation Height.
   * Default value is 0.
   *
   * @type {number}
   */
  elevation: PropTypes.number,
};
